import { PropsWithChildren, useCallback, useState } from 'react';
import styled from 'styled-components';
import { palette } from 'styles/color';

interface DndBoxProps {
  onChange: (file: File) => void;
}

export default function DndBox(props: PropsWithChildren<DndBoxProps>) {
  const [dragging, setDragging] = useState(false);

  const prevent = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  return (
    <DndBoxBase
      $isDragging={dragging}
      onDragEnter={(e) => {
        prevent(e);
        setDragging(true);
      }}
      onDragLeave={(e) => {
        prevent(e);
        setDragging(false);
      }}
      onDragOver={(e) => {
        prevent(e);
        if (e.dataTransfer.files) {
          setDragging(true);
        }
      }}
      onDrop={(e) => {
        prevent(e);
        props.onChange(e.dataTransfer.files[0]);
        setDragging(false);
      }}>
      {props.children}
    </DndBoxBase>
  );
}

const DndBoxBase = styled.div<{ $isDragging: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 19px;

  background-color: ${({ $isDragging }) =>
    $isDragging ? `${palette.blue[100]}` : `${palette.transparent}`};
`;
